<template>
  <div class="account-detail-container">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="block">
          <div class="avatar-wrap clearfix" v-if="list.length > 0">
            <img class="avatar fleft" :src="list[0].avatar" lazy="loaded">
            <div class="info fleft">
              <p class="name">{{list[0].accountName}}</p>
              <p class="time">最近更新 {{list[0].dateTime}}</p>
            </div>
            <div class="fleft category-wrap" v-if="list && list[0].categories"  @click='onShowModel'>
              <div v-if="!list[0].categories[0] || list[0].categories[0].categoryId == 0">
                <button class="button is-success">还未分类,点击添加</button>
              </div>
              <div v-else>
                <span class="category" v-for="(item,key) in list[0].categories">{{item.categoryName}}</span>
              </div>
            </div>
            <div v-else="fleft category-wrap">
              <button class="button is-success">还未分类,点击添加</button>
            </div>
          </div>
        </div>
      </article>
    </div>
    <div class="list-wrap">
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <waterfall :column-width="380">
            <div class="waterfall-container">
              <div v-for="(item,key) in list" class="card-item waterfall-item">
                <div class="item-container">
                  <p class="time">最近更新时间: {{item.dateTime}}</p>
                  <account-card :item-messagedata="item.messageList" :item-categorylist="item.categoryIds" @subscribe-click="subscribeClick"></account-card>
                </div>
              </div>
            </div>
          </waterfall>
        </article>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
    <category-modal ref="categoryModalRef" :item="modal.item" :item-categorylist='modal.itemCategorylist' @update-category-event="updateCategoryEvent"></category-modal>
    <thread-base-modal ref="threadBaseModalRef" :message-title="messageTitle" @do-save-tread-event="doSaveTreadEvent"></thread-base-modal>
  </div>
</template>
<script type="text/babel">
  import waterfall from 'COMMON/waterfall/waterfall.vue'
  import AccountCard from '../common/accountCard/accountCard';
  import ThreadBaseModal from '../common/threadBaseModal/threadBaseModal';
  import CategoryModal from '../common/categoryModal/categoryModal';
  import {mapActions} from 'vuex';
  import {formatImageByQiniu} from 'UTILS/_url'
  import {formatDate} from 'UTILS/date'


  export default {
    components: {
      waterfall,AccountCard,ThreadBaseModal,CategoryModal
    },
    data(){
      return {
        accountNumber:"",//公众号
        accountData:{},//抓取的文章数据
        threadBaseInfo:{},//帖子的基本信息
        visible:false,
        list:[],
        currentPage:1,
        pageSize:20,
        count:1,
        modal:{
          item: {},
          name:"",
          itemCategorylist: {}
        },
        messageTitle:""//当前要抓取的文章名称
      }
    },
    mounted(){
      this.accountNumber = this.$route.query.accountNumber;
      this.getAccountDetail();
    },
    methods: {
      ...mapActions([
        'commitWaterfallUpdate'
      ]),
      //分类更新
      updateCategoryEvent(data){
        this.list[0].categories = data;
      },
      //帖子编辑保存监听
      doSaveTreadEvent(data){
        this.threadBaseInfo = data;
        this.doSaveAsThread();
      },
      //抓取点击监听
      subscribeClick(data){
        this.messageTitle = data.title;
        this.accountData = data;
        this.$refs.threadBaseModalRef && this.$refs.threadBaseModalRef.showModal();
      },
      //分页监听
      handleCurrentChange(value) {
        if(this.currentPage !== value){
          this.currentPage = value;
          this.getAccountDetail();
        }
      },
      getAccountDetail(){
        let params = {
          categoryId:[],
          accountNumber:this.accountNumber,
          page:this.currentPage,
          pageSize:this.pageSize
        }
        HttpRequest.get('/admin.php?method=wechat.getUpdateList', params, true).then((response) => {
          this.list =_.toArray(response.data.list);
          this.count = response.data.count;
          _.each(this.list,(item,index)=>{
            item.avatar = formatImageByQiniu(item.avatar,100,100);
            item.dateTime = formatDate(item.dateTime,'yyyy-MM-dd hh:mm:ss');
            if(_.size(item.messageList) == 1){
              item.itemHieght = 320;
            }else if(_.size(item.messageList) > 1){
              item.itemHieght = 260+70*(_.size(item.messageList)-1)
            }
            _.each(item.messageList,(list,k)=>{
              list.accountNumber = item.accountNumber;
            })
          })
          this.commitWaterfallUpdate(true);
        })
      },
      //抓取保存
      doSaveAsThread(){
        let params = Object.assign(this.threadBaseInfo,{
          accountNumber:this.accountData.accountNumber,
          fileId:this.accountData.fileId,
          msgId:this.accountData.msgId
        });
        HttpRequest.post("/admin.php?method=wechat.doSaveAsThread", params, true).then((response) => {
          if (response.data.result == true) {
            if(!confirm('帖子已经生成,ID'+response.data.threadId+',是否跳转至帖子详情?')){
              return false;
            }
            let link = document.createElement("a");
            link.href =  "/adminv/#!/threadEdit?threadId="+response.data.threadId
            link.target = '_blank'
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }else{
            alert("生成失败!")
          }
        }, (response) => {

        });
      },
      //编辑分类
      onShowModel() {
        this.modal.item = {accountNumber: this.accountNumber};
        this.modal.itemCategorylist = this.list[0].categories;
        this.$refs.categoryModalRef && this.$refs.categoryModalRef.showModal()
      },
    }
  }
</script>
<style lang="less">
  .category-wrap{
    width: 60%;
    margin-left:20px;
    .category{
      background: #eaeaea;
      padding: 5px 10px;
      color: #333;
      margin: 0 10px 10px 0;
      display: inline-block;
    }
  }
  .item-container{
    padding: 20px;
    width: 380px;
    height: 96%;
    display: inline-block;
    border: 2px solid #efefef;
    border-radius: 5px;
    margin-bottom:20px;
    .time{
      font-size: 18px;
      color: #000;
      margin-bottom: 10px;
    }
  }
  .avatar-wrap{
    margin-bottom: 10px;
    .info{
      margin-left:20px;
      .name{
        font-size: 20px;
        color: #333;
        font-weight: 500;
        width: 150px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
      }
      .time{
        font-size: 14px;
        color: #666;
      }
    }
    .avatar{
      width: 60px;
      height: 60px;
      border-radius: 60px;
    }
  }
</style>
